import { FC, ReactNode } from "react";
// import Modal from "./Modal";
import { UseToggleStateReturn } from "hooks/useToggleState";
import { toast } from "react-hot-toast";
import ReactModal from "react-modal";

const ConfirmationModal: FC<{
	onConfirm: (...args: any) => any;
	body: ReactNode;
	title?: string;
	modalToggle: UseToggleStateReturn;
	validation?: () => boolean;
	validationMessage?: string;
	disabled?: boolean;
}> = ({ body, onConfirm, title = "Confirm?", modalToggle, validation = () => true, validationMessage = "", disabled }) => {
	return (
		<ReactModal
			isOpen={modalToggle.isToggled}
			onRequestClose={modalToggle.off}
			ariaHideApp={false}
			className="max-h-[80vh] min-w-[256px] w-[60vw] overflow-y-auto bg-gray-primary rounded p-4 pt-1 absolute-center"
		>
			{title}
			<div className="flex flex-col gap-y-5">
				<div className="text-secondary flex justify-center">{body}</div>
				<div className="flex space-x-1 justify-around">
					<button
						className="bg-primary px-3 py-1.5 rounded flex-1"
						type="button"
						onClick={() =>
							validation() ? Promise.resolve(onConfirm()).then(modalToggle.off) : toast.error(validationMessage || "Error Confirming")
						}
						disabled={disabled}
					>
						Submit
					</button>
					<button className="bg-secondary text-black px-3 py-1.5 rounded flex-1" onClick={modalToggle.off} disabled={disabled}>
						Cancel
					</button>
				</div>
			</div>
		</ReactModal>
	);
};

export default ConfirmationModal;
